<div class="border-grey height-min-15 radius-lg hide-on-mobile">
  <div class="grid-container padding-3">
    <div class="grid-row">
      <h2 class="h2-as-h3 grid-col-12 margin-top-0">Resources</h2>
    </div>
    <hdw-resource-content-items></hdw-resource-content-items>
  </div>
</div>

<div class="grid-row hide-on-desktop">
  <div class="grid-col-12 border-top-grey">
    <div class="usa-accordion padding-bottom-4">
      <h4 class="usa-accordion__heading">
        <button
          type="button"
          class="usa-accordion__button background-color-light-blue"
          [attr.aria-expanded]="canShowResources"
          aria-controls="resources"
          (click)="handleCanShowResources()"
        >
          Resources
        </button>
      </h4>
      <div id="resources" class="usa-accordion__content border-grey margin-top-1" [hidden]="!canShowResources">
        <hdw-resource-content-items></hdw-resource-content-items>
      </div>
    </div>
  </div>
</div>
